import { ExpandMore } from '@mui/icons-material';
import FinalKitchenGIVarianceReportTable from '../../../../../components/commonComponent/VarianceReportTable/FinalKitchenGIVarianceReportTable';

interface ListDataProps {
  openIndices: number[];
  handleToggle: (index: number) => void;
  data?: any;
}

const ListData: React.FC<ListDataProps> = ({ openIndices, handleToggle, data }) => {
  return (
    <>
      {data.map((item: any, index: number) => (
        <div className={`innrBox ${openIndices.includes(index) ? 'active' : ''}`}>
          <div className='flex align-items-center justify-content-between'>
            <button
              onClick={() => handleToggle(index)}
              className={`flex align-items-center dropDownButton wd-140 ${
                openIndices.includes(index) ? 'active' : ''
              }`}
            >
              <span>
                <ExpandMore />
              </span>{' '}
              {item?.daypartname}
            </button>          
          </div>
          {openIndices.includes(index) && (
            <div className='content'>
              <FinalKitchenGIVarianceReportTable tableData={item?.kitchenindentlist}/>
            </div>
          )}
        </div>
      ))}
    </>
  );
};

export default ListData;
